<div class="card">
    <div class="card-inner">
        <div class="image-container">
            <div class="image">
                <app-product-image [index]="index"
                                   [image]="{ src: line.imageUrl, name: line.productName }"></app-product-image>
            </div>

            <app-product-splashes [compressed]="compressed" [product]="line"
                                  [displayCampaigns]="displayCampaigns"></app-product-splashes>
        </div>
        <div class="description">
            <app-brand-link *ngIf="line.brand" [brand]="line.brand"></app-brand-link>
            <div class="name"
                 [ngClass]="{
                    'small-name': compressed,
                    'auto-height': layout === 'mini'
                  }">
                {{ line.productName | stringTruncate : 65 }}
            </div>
        </div>
        <app-product-price
            [line]="line"
            [type]="compressed ? 'lite' : 'regular'"
            [settings]="{ showPoints: false, forceEqualHeight: false }"
            pointPosition="left"
        ></app-product-price>

        <a [routerLink]="line.productUrl"
           [state]="{ productId: line.productNo }"
           [queryParams]="queryParamsHandling === 'merge' && (line.activeCampaigns | getCampaignType: 'Mixed') ? { 'campaignId': (line.activeCampaigns | getCampaignType: 'Mixed')?.campaignId } : null"
           [queryParamsHandling]="queryParamsHandling"
           (click)="productClick(line)" class="kk-link-cover"
        ><span class="kk-visuallyhidden">{{ line.productName }}</span></a
        >
    </div>

    <div class="actions" *ngIf="displayActions">
        <app-product-actions [line]="line" variant="simple"></app-product-actions>
    </div>
</div>
